import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { getSectionByPath } from "../constants/sections";
import { recordRecentSection } from "../utils/recentSections";

// Registra como "acceso reciente" la sección de la URL actual, solo si el path
// pertenece al catálogo de secciones (ignora "/", "/login", registros, etc.).
// Se invoca desde el layout, que envuelve toda página autenticada.
export const useRecordRecentSection = (role) => {
  const { pathname, search } = useLocation();

  useEffect(() => {
    const section = getSectionByPath(pathname, role);
    if (section) recordRecentSection(section.path);
    // `search` incluido para re-evaluar al cambiar query (p. ej. /reportes?x).
  }, [pathname, search, role]);
};
